<template>
  <div
    :class="[
      'job-item-long',
      {
        'job-item-long--editable': !isEditable
      }
    ]"
  >
    <custom-checkbox
      v-if="isEditable"
      v-model="toggled"
      icon="check2"
      :scale="1.75"
    ></custom-checkbox>
    <router-link class="job-item-long__img" :to="to">
      <div
        :style="{
          backgroundImage: 'url(' + jobImage + ')',
          backgroundSize: 'contain',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }"
      ></div>
    </router-link>
    <router-link class="job-item-long__content" :to="to">
      <h4 class="job-title">{{ job.name }}</h4>
      <p class="job-desc">{{ job.description | tooLong }}</p>
      <h5>${{ job.price | price }}/day</h5>
    </router-link>
    <router-link v-if="isEditable" class="job-item-long__btn" :to="toEdit">
      <div class="edit-btn">
        <b-img :src="require('@/assets/icons/edit.svg')"></b-img>
      </div>
    </router-link>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * VUE Component
 * ==================================================================================
 **/

import Job from '@/models/Job'
import CustomCheckbox from '@/components/inputs/CustomCheckbox'

export default {
  components: {
    CustomCheckbox
  },
  props: {
    job: {
      type: [Job, Object],
      required: true
    },

    isEditable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    jobImage() {
      if (!this.job || !this.job.gallery || !this.job.gallery.length)
        return require('@/assets/images/img-placeholder.svg')
      return (
        this.job.gallery[0].thumb_url ||
        this.job.gallery[0].permanent_url ||
        this.job.gallery[0].url
      )
    },

    to() {
      return {
        name: 'job.view-job-page',
        params: {
          id: this.job.permalink,
          title: this.job.name.replace(/ +/g, '-').toLowerCase()
        }
      }
    },

    toEdit() {
      return {
        name: 'job.edit-job-page',
        params: {
          id: this.job.permalink,
          title: this.job.name.replace(/ +/g, '-').toLowerCase()
        }
      }
    }
  },
  watch: {
    toggled(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('change', this.job.id)
      }
    }
  },
  data: function() {
    return {
      toggled: false,
      imgProps: {
        center: true,
        blank: true,
        height: '125px',
        width: 'auto'
      }
    }
  }
}
</script>
